"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions");

var _constants = require("./constants");

var _actions2 = require("settings-ui-sdk/EcommerceImport/actions");

var _constants2 = require("settings-ui-sdk/EcommerceImport/constants");

var _actions3 = require("settings-ui-sdk/ShopifyConnection/actions");

var _handleActions;

var initialState = new _immutable.Map({
  integrationStatus: null,
  shop: new _immutable.Map({
    id: null,
    myshopifyDomain: null,
    name: null,
    storeName: null
  }),
  shopifyUrlIsValid: null,
  ecommBridgeAppIsInstalled: false
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchShopifyStatusActionTypes.SUCCESS, function (state, action) {
  return state.set('integrationStatus', _constants.IntegrationStatuses[action.payload.data.integrationStatus]);
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchShopifyShopActionTypes.SUCCESS, function (state, action) {
  return state.set('shop', new _immutable.Map(action.payload.data));
}), (0, _defineProperty2.default)(_handleActions, _actions.DisconnectShopifyActionTypes.SUCCESS, function (state) {
  return state.set('integrationStatus', _constants.IntegrationStatuses.NOT_INTEGRATED).set('ecommBridgeAppIsInstalled', false);
}), (0, _defineProperty2.default)(_handleActions, _actions2.FetchEcommerceImportDetailsActionTypes.SUCCESS, function (state, action) {
  if (action.payload.data.stage === _constants2.ImportStages.COMPLETE) {
    return state.set('ecommBridgeAppIsInstalled', true);
  }

  return state;
}), (0, _defineProperty2.default)(_handleActions, _actions3.ShopifyConnectionActionTypes.FINISH_SHOPIFY_CONNECTION, function (state) {
  return state.set('ecommBridgeAppIsInstalled', true);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;